import { render, staticRenderFns } from "./SaleArticlesAttachmentTable.vue?vue&type=template&id=fa444c16&"
import script from "./SaleArticlesAttachmentTable.vue?vue&type=script&lang=js&"
export * from "./SaleArticlesAttachmentTable.vue?vue&type=script&lang=js&"
import style0 from "./SaleArticlesAttachmentTable.vue?vue&type=style&index=0&id=fa444c16&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports